import React from 'react';
import Modal from '@mui/material/Modal';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';

const ModalStyled = styled(Modal)(
  () => `
  .modalContainer {
    position: absolute;
    width: 90%;
    max-width: 500px;
    background-color: #f9f9f9;
    border: 1px solid black;
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.1);
    padding: 0;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .modalHeader {
    padding: 15px;
    font-size: 1.1rem;
    font-weight: 900;
    background-color: #f9f9f9;
    width: auto;
    position: relative;
  }
  .modalBody {
    padding: 15px;
    width: auto;
    position: relative;
  }
  .modalFooter {
    padding: 15px;
    border-top: 1px solid gray;
    background-color: #f9f9f9;
    text-align: right;
    position: relative;
    width: auto;
  }
`,
);

const ConnectionLostModal = ({
  open, header, body, footer, handleClose,
}) => (
  <>
    <ModalStyled
      open={open}
      onClose={handleClose}
      aria-labelledby="ConnectionLostModal"
      aria-describedby="ConnectionLostModal"
      BackdropProps={{
        style: { backgroundColor: 'rgba(255,255,255,0.85)' },
      }}
    >
      <div className="modalContainer">
        {header && (
          <div className="modalHeader">
            { header }
          </div>
        ) }
        { body && (
          <div className="modalBody">
            { body }
          </div>
        ) }
        { footer && (
          <div className="modalFooter">
            { footer }
          </div>
        ) }
      </div>
    </ModalStyled>
  </>
);

ConnectionLostModal.propTypes = {
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func,
  header: PropTypes.string,
  body: PropTypes.string,
  footer: PropTypes.element,
};

ConnectionLostModal.defaultProps = {
  handleClose: null,
  header: null,
  body: null,
  footer: null,
};

export default ConnectionLostModal;
